import {useCourses} from "../useCourses";
import CourseCard from "./CourseCard";
import {CourseSkeleton} from "./ui";

export default function LearningCatalog() {
  const { courses, isLoading, error, mutate } = useCourses();

  return (
    <div>
      <div className="mb-3">
        <h2 className="mb-1">Learning Center</h2>
        <p className="text-muted mb-0">
          Courses to help you grow your affiliate business.
        </p>
      </div>

      {error && (
        <div className="alert alert-danger d-flex align-items-center justify-content-between">
          <span>{error?.message || "Failed to load courses"}</span>
          <button
            className="btn btn-sm btn-outline-danger"
            onClick={() => mutate()}
          >
            Retry
          </button>
        </div>
      )}

      {isLoading ? (
        <CourseSkeleton />
      ) : (
        <>
          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3">
            {courses.map((course) => (
              <CourseCard key={course.id} course={course} />
            ))}
          </div>
          {courses.length === 0 && !error && (
            <p className="text-muted">No courses available yet.</p>
          )}
        </>
      )}
    </div>
  );
}
